import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from '../data/translations';
import { Menu, X, Globe } from 'lucide-react';

export const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isRTL = language === 'ar';

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="relative p-2 bg-gradient-to-br from-gray-900/80 to-black/80 rounded-xl border border-teal-500/30 backdrop-blur-sm">
              <img 
                src="/rafan-logo.png" 
                alt="Rafan Group" 
                className="w-14 h-14 object-contain drop-shadow-[0_0_8px_rgba(20,184,166,0.5)]"
              />
              <div className="absolute inset-0 bg-teal-500/5 rounded-xl"></div>
            </div>
            <div className={`${isRTL ? 'text-right' : 'text-left'}`}>
              <h1 className="text-xl font-bold text-white tracking-wide">Rafan Group</h1>
              <p className="text-xs text-teal-400 font-medium">{t.hero.pioneer}</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-white hover:text-teal-400 transition-colors duration-300">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-white hover:text-teal-400 transition-colors duration-300">
              {t.nav.about}
            </button>
            <button onClick={() => scrollToSection('services')} className="text-white hover:text-teal-400 transition-colors duration-300">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-white hover:text-teal-400 transition-colors duration-300">
              {t.nav.contact}
            </button>
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-all duration-300"
            >
              <Globe className="w-4 h-4" />
              <span className="font-medium">{language === 'en' ? 'العربية' : 'English'}</span>
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-3">
            <button
              onClick={toggleLanguage}
              className="p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-all duration-300"
            >
              <Globe className="w-5 h-5" />
            </button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white transition-all duration-300"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('home')} className="text-white hover:text-teal-400 transition-colors duration-300 text-left px-4 py-2">
                {t.nav.home}
              </button>
              <button onClick={() => scrollToSection('about')} className="text-white hover:text-teal-400 transition-colors duration-300 text-left px-4 py-2">
                {t.nav.about}
              </button>
              <button onClick={() => scrollToSection('services')} className="text-white hover:text-teal-400 transition-colors duration-300 text-left px-4 py-2">
                {t.nav.services}
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-white hover:text-teal-400 transition-colors duration-300 text-left px-4 py-2">
                {t.nav.contact}
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};